import { render, staticRenderFns } from "./HotelTravelers.vue?vue&type=template&id=15124644&"
import script from "./HotelTravelers.vue?vue&type=script&lang=js&"
export * from "./HotelTravelers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GIT\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15124644')) {
      api.createRecord('15124644', component.options)
    } else {
      api.reload('15124644', component.options)
    }
    module.hot.accept("./HotelTravelers.vue?vue&type=template&id=15124644&", function () {
      api.rerender('15124644', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/Components/HotelTravelers.vue"
export default component.exports